// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap:1rem
}

.suggestions-box {
    display: flex;
    flex-wrap: wrap;
    margin: 1rem 0;
  }
  
  .suggestion {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px 10px;
    margin: 5px;
    cursor: pointer;
    color: white;
  }

  .dark .suggestion {
    background-color: var(--dark-blue);
  }
  
  .suggestion:hover {
    background-color: #e0e0e0;
    color: black;
  }

  .record-payment-button{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 2rem;
  }`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/orders/components/recordPaymentModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB","sourcesContent":[".main-container-box{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap:1rem\n}\n\n.suggestions-box {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 1rem 0;\n  }\n  \n  .suggestion {\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 5px 10px;\n    margin: 5px;\n    cursor: pointer;\n    color: white;\n  }\n\n  .dark .suggestion {\n    background-color: var(--dark-blue);\n  }\n  \n  .suggestion:hover {\n    background-color: #e0e0e0;\n    color: black;\n  }\n\n  .record-payment-button{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 2rem;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
